import { PERMISSION_LEVEL_CONSTS } from '@/utilities/appConsts'

export function hasResourcePermission(permission, userPermissions) {
  var hasOneOfThesePermissionsLevel
  if (Array.isArray(permission)) {
    hasOneOfThesePermissionsLevel = permission.filter(userPermissionlevel => {
      return userPermissions.find(
        element =>
          element.name == userPermissionlevel.resource &&
          hasResourcePermissionLevel(
            element.permissionLevel,
            userPermissionlevel.permissionLevel,
          ),
      )
    })

    return hasOneOfThesePermissionsLevel.length > 0 ? true : false
  } else {
    hasOneOfThesePermissionsLevel = userPermissions.find(
      element =>
        element.name == permission.resource &&
        hasResourcePermissionLevel(
          element.permissionLevel,
          permission.permissionLevel,
        ),
    )
    return hasOneOfThesePermissionsLevel &&
      Object.keys(hasOneOfThesePermissionsLevel).length > 0
      ? true
      : false
  }
}

function hasResourcePermissionLevel(
  userPermissionLevel,
  requiredPermissionLevel,
) {
  const permissionLevels = []
  if (userPermissionLevel - PERMISSION_LEVEL_CONSTS.DELETE >= 0) {
    permissionLevels.push(PERMISSION_LEVEL_CONSTS.DELETE)
    userPermissionLevel = userPermissionLevel - PERMISSION_LEVEL_CONSTS.DELETE
  }
  if (userPermissionLevel - PERMISSION_LEVEL_CONSTS.EDIT >= 0) {
    permissionLevels.push(PERMISSION_LEVEL_CONSTS.EDIT)
    userPermissionLevel = userPermissionLevel - PERMISSION_LEVEL_CONSTS.EDIT
  }
  if (userPermissionLevel - PERMISSION_LEVEL_CONSTS.READ >= 0) {
    permissionLevels.push(PERMISSION_LEVEL_CONSTS.READ)
    userPermissionLevel = userPermissionLevel - PERMISSION_LEVEL_CONSTS.READ
  }
  return (
    permissionLevels &&
    permissionLevels.some(p => p === requiredPermissionLevel)
  )
}
